import React, { useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import _ from "lodash";
import { useRouteMatch } from "react-router";

import withAuthority from "../../../../components/Auth/withAuthority";
import { getCookie } from "../../../../utils/cookies";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";
import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import Authorities from "../../../../auth/authorities";
import { fetchAllDriverSessionReportInfo } from "../../../../services/salesApp/driverSessionSummaryReport";
import SaleReportOneDate from "../../../../components/common/SaleReportOneDate";
import HourlySalesReportNode from "./HourlySalesReportNode";
import SaleReport from "../../../../components/common/SaleReport";
import {
  hourlySalesFilterObject,
  salesItemsFilterObject,
} from "../../../../utils/consts/list";
import { fetchAllItemsReportVersion2Info } from "../../../../services/salesApp/itemsReportService";
import {
  fetchHourlySalesReport,
  fetchMonthlySalesReport,
  fetchWeeklySalesReport,
} from "../../../../services/salesApp/hourlySalesReport";

/**
 * MonthlySalesReport Component:
 *
 * This component manages the display of shift-related information and interactions,
 * including filtering, sorting, pagination, and error handling. It fetches data from
 * backend APIs and renders shift reports and lists accordingly. The component integrates
 * with user authentication to control access based on user permissions.
 */
const MonthlySalesReport: React.FunctionComponent<{}> = () => {
  const [driverSummaryNodeList, setDriverSummaryNodeList] = useState<any>([]);
  const [error, setError] = useState("");
  const [isLoadingPage, setIsLoadingPage] = useState(false);
  const [weeklySales, setWeeklySales] = useState<any>({});
  const [weeklySalesCountValue, setWeeklySalesCountValue] = useState<any>({});
  const [weeklySalesTotalValue, setWeeklySalesTotalValue] = useState<any>({});
  const [filterData, setFilterData] = useState("");
  const [filterDetails, setFilterDetails] = useState("");
  const [openFilterCard, setOpenFilterCard] = useState(false);
  const [locationSelectorList, setLocationSelectorList] = useState<any>([]);
  const [isGetLocationInfo, setIsGetLocationInfo] = useState(false);
  const [locationSelectedList, setLocationSelectedList] = useState([]);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const extractDateRange = (input: any) => {
    const parts = input.split(",");

    let startDate: any = null;
    let endDate: any = null;

    parts.forEach((part: any) => {
      const match = part.match(/date([<>]=)(\d{4}-\d{2}-\d{2})/);
      if (match) {
        const [, operator, date] = match;
        if (operator === ">=") {
          if (!startDate || date > startDate) {
            startDate = date;
          }
        } else if (operator === "<=") {
          if (!endDate || date < endDate) {
            endDate = date;
          }
        }
      }
    });

    return { startDate, endDate };
  };

  const days = {
    "2025-01-02": [
      {
        hour: 12,
        saleCount: 7,
        saleTotal: 50.98,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 105.65,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 70.2,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 22.9,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 64.8,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 31.42,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 18.4,
      },
    ],
    "2025-01-03": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 34.9,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 60.55,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 43.35,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 0.01,
      },
      {
        hour: 17,
        saleCount: 6,
        saleTotal: 117.7,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 150.5,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 33.01,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 24.18,
      },
    ],
    "2025-01-04": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 14.15,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 20.0,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 16.9,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 67.9,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 69.25,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 79.75,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 41.32,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 122.2,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 12.45,
      },
    ],
    "2025-01-05": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 22.38,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 37.35,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 22.9,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 105.6,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 91.22,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 17.45,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 0.0,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 7.95,
      },
    ],
    "2025-01-06": [
      {
        hour: 11,
        saleCount: 4,
        saleTotal: 58.25,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 43.85,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 15.95,
      },
      {
        hour: 14,
        saleCount: 6,
        saleTotal: 74.75,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 50.8,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 144.03,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 116.59,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 17.9,
      },
    ],
    "2025-01-07": [
      {
        hour: 11,
        saleCount: 4,
        saleTotal: 64.8,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 31.9,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 9.95,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 18.45,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 29.9,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 61.3,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 44.4,
      },
    ],
    "2025-01-08": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 35.85,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 18.9,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 10.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 29.4,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 15.95,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 17.45,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 7.95,
      },
    ],
    "2025-01-09": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 50.8,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 29.5,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 21.9,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 50.8,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 49.8,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 24.9,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 0.0,
      },
    ],
    "2025-01-10": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 86.85,
      },
      {
        hour: 13,
        saleCount: 6,
        saleTotal: 17.9,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 24.9,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 62.8,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 21.9,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 202.85,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 63.27,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 87.1,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 44.95,
      },
    ],
    "2025-01-11": [
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 54.75,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 56.99,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 88.26,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 71.14,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 133.7,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 56.43,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 103.72,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 14.45,
      },
    ],
    "2025-01-12": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 5.5,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 16.45,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 72.65,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 9.45,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 38.9,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 36.56,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 28.9,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 65.54,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 61.1,
      },
    ],
    "2025-01-13": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 35.4,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 23.9,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 53.3,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 0.0,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 52.4,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 15.57,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 95.2,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 32.95,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 61.25,
      },
    ],
    "2025-01-14": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 51.3,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 32.9,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 23.85,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 96.37,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 118.85,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 38.95,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 35.8,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 74.05,
      },
    ],
    "2025-01-15": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 71.5,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 24.85,
      },
      {
        hour: 15,
        saleCount: 8,
        saleTotal: 8.95,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 24.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 13.9,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 29.35,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 6.95,
      },
    ],
    "2025-01-16": [
      {
        hour: 13,
        saleCount: 5,
        saleTotal: 84.05,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 25.0,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 149.99,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 131.32,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 13.9,
      },
    ],
    "2025-01-17": [
      {
        hour: 11,
        saleCount: 5,
        saleTotal: 50.75,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 19.9,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 47.95,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 26.9,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 58.3,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 119.32,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 49.03,
      },
    ],
    "2025-01-18": [
      {
        hour: 11,
        saleCount: 3,
        saleTotal: 0.0,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 38.35,
      },
      {
        hour: 15,
        saleCount: 4,
        saleTotal: 175.73,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 55.35,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 110.5,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 113.17,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 154.55,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 123.0,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 110.55,
      },
    ],
    "2025-01-19": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 20.9,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 21.9,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 54.32,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 19.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 78.2,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 44.8,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 152.38,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 35.77,
      },
    ],
    "2025-01-20": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 35.25,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 12.45,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 20.95,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 34.75,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 41.65,
      },
    ],
    "2025-01-21": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 86.33,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 9.95,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 35.4,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 42.8,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 110.15,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 11.45,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 9.87,
      },
    ],
    "2025-01-22": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 18.9,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 50.35,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 33.8,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 15.45,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 25.94,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 59.74,
      },
    ],
    "2025-01-23": [
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 99.15,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 66.8,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 4.48,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 163.3,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 33.6,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 114.95,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 92.13,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 58.7,
      },
    ],
    "2025-01-24": [
      {
        hour: 12,
        saleCount: 5,
        saleTotal: 210.9,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 38.85,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 62.7,
      },
      {
        hour: 15,
        saleCount: 4,
        saleTotal: 112.6,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 32.35,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 52.25,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 79.6,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 91.0,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 39.11,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 29.9,
      },
    ],
    "2025-01-25": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 30.4,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 193.97,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 32.33,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 43.4,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 147.22,
      },
      {
        hour: 18,
        saleCount: 8,
        saleTotal: 200.65,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 229.4,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 123.39,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 69.1,
      },
    ],
    "2025-01-26": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 30.9,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 10.0,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 35.59,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 48.6,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 11.14,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 52.6,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 217.76,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 114.18,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 4.47,
      },
    ],
    "2025-01-27": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 16.0,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 61.19,
      },
      {
        hour: 13,
        saleCount: 8,
        saleTotal: 94.42,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 20.96,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 117.01,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 65.95,
      },
      {
        hour: 18,
        saleCount: 9,
        saleTotal: 164.82,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 118.26,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 41.8,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 60.75,
      },
    ],
    "2025-01-28": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 12,
        saleCount: 6,
        saleTotal: 115.69,
      },
      {
        hour: 13,
        saleCount: 6,
        saleTotal: 101.13,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 47.58,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 15.53,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 65.53,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 101.08,
      },
      {
        hour: 18,
        saleCount: 8,
        saleTotal: 203.72,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 34.75,
      },
      {
        hour: 20,
        saleCount: 7,
        saleTotal: 167.8,
      },
      {
        hour: 21,
        saleCount: 6,
        saleTotal: 43.85,
      },
    ],
    "2025-01-29": [
      {
        hour: 11,
        saleCount: 3,
        saleTotal: 42.8,
      },
      {
        hour: 12,
        saleCount: 7,
        saleTotal: 127.02,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 22.0,
      },
      {
        hour: 14,
        saleCount: 7,
        saleTotal: 109.51,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 22.37,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 67.69,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 32.28,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 115.84,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 169.55,
      },
      {
        hour: 20,
        saleCount: 11,
        saleTotal: 300.56,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 27.93,
      },
    ],
    "2025-01-30": [
      {
        hour: 11,
        saleCount: 4,
        saleTotal: 54.04,
      },
      {
        hour: 12,
        saleCount: 8,
        saleTotal: 129.95,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 71.27,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 43.1,
      },
      {
        hour: 15,
        saleCount: 5,
        saleTotal: 107.54,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 83.63,
      },
      {
        hour: 18,
        saleCount: 14,
        saleTotal: 360.71,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 189.4,
      },
      {
        hour: 20,
        saleCount: 11,
        saleTotal: 215.91,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 51.94,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 6.95,
      },
    ],
    "2025-01-31": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 162.84,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 122.53,
      },
      {
        hour: 13,
        saleCount: 5,
        saleTotal: 131.65,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 37.35,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 65.91,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 85.28,
      },
      {
        hour: 17,
        saleCount: 11,
        saleTotal: 221.16,
      },
      {
        hour: 18,
        saleCount: 14,
        saleTotal: 341.25,
      },
      {
        hour: 19,
        saleCount: 11,
        saleTotal: 294.05,
      },
      {
        hour: 20,
        saleCount: 14,
        saleTotal: 322.16,
      },
      {
        hour: 21,
        saleCount: 12,
        saleTotal: 343.88,
      },
      {
        hour: 22,
        saleCount: 4,
        saleTotal: 62.82,
      },
    ],
    "2025-02-01": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 47.95,
      },
      {
        hour: 13,
        saleCount: 8,
        saleTotal: 157.2,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 124.01,
      },
      {
        hour: 15,
        saleCount: 5,
        saleTotal: 124.41,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 95.3,
      },
      {
        hour: 17,
        saleCount: 8,
        saleTotal: 141.95,
      },
      {
        hour: 18,
        saleCount: 13,
        saleTotal: 324.01,
      },
      {
        hour: 19,
        saleCount: 17,
        saleTotal: 545.19,
      },
      {
        hour: 20,
        saleCount: 10,
        saleTotal: 266.25,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 60.38,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 14.45,
      },
    ],
    "2025-02-02": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 41.9,
      },
      {
        hour: 12,
        saleCount: 5,
        saleTotal: 142.3,
      },
      {
        hour: 13,
        saleCount: 5,
        saleTotal: 111.7,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 33.85,
      },
      {
        hour: 15,
        saleCount: 7,
        saleTotal: 137.2,
      },
      {
        hour: 16,
        saleCount: 8,
        saleTotal: 281.54,
      },
      {
        hour: 17,
        saleCount: 9,
        saleTotal: 227.61,
      },
      {
        hour: 18,
        saleCount: 9,
        saleTotal: 256.78,
      },
      {
        hour: 19,
        saleCount: 14,
        saleTotal: 446.16,
      },
      {
        hour: 20,
        saleCount: 10,
        saleTotal: 240.1,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 76.52,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 51.05,
      },
    ],
    "2025-02-03": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 65.69,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 31.58,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 33.85,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 31.9,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 148.2,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 30.85,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 36.4,
      },
    ],
    "2025-02-04": [
      {
        hour: 11,
        saleCount: 7,
        saleTotal: 144.87,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 71.97,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 7.16,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 33.4,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 36.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 98.05,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 48.3,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 34.85,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 100.38,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 85.82,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 0.0,
      },
    ],
    "2025-02-05": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 13.9,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 45.25,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 23.4,
      },
      {
        hour: 15,
        saleCount: 6,
        saleTotal: 113.6,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 67.3,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 38.3,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 80.25,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 81.99,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 30.9,
      },
    ],
    "2025-02-06": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 47.8,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 10.95,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 32.38,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 142.41,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 64.15,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 38.85,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 65.04,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 79.2,
      },
    ],
    "2025-02-07": [
      {
        hour: 12,
        saleCount: 6,
        saleTotal: 116.05,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 25.4,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 72.45,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 36.27,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 69.25,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 120.65,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 163.61,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 122.06,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 104.52,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 103.29,
      },
    ],
    "2025-02-08": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 17.45,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 56.45,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 78.75,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 73.75,
      },
      {
        hour: 17,
        saleCount: 7,
        saleTotal: 255.91,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 126.79,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 163.05,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 23.85,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 50.2,
      },
    ],
    "2025-02-09": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 22.85,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 36.3,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 49.8,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 38.8,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 198.65,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 14.76,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 120.49,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 100.85,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 160.09,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 76.8,
      },
    ],
    "2025-02-10": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 15.12,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 14.95,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 85.76,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 48.21,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 81.7,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 31.84,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 98.54,
      },
    ],
    "2025-02-11": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 21.45,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 18.9,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 34.1,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 16.15,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 30.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 74.35,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 83.65,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 54.14,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 129.62,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 49.1,
      },
    ],
    "2025-02-12": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 9.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 97.64,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 135.77,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 57.12,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 37.9,
      },
    ],
    "2025-02-13": [
      {
        hour: 11,
        saleCount: 5,
        saleTotal: 84.96,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 33.26,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 125.55,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 36.35,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 66.65,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 45.38,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 44.35,
      },
    ],
    "2025-02-14": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 36.77,
      },
      {
        hour: 12,
        saleCount: 5,
        saleTotal: 170.0,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 42.07,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 43.35,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 49.85,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 77.85,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 69.7,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 126.51,
      },
      {
        hour: 19,
        saleCount: 10,
        saleTotal: 378.89,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 33.05,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 123.35,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 41.8,
      },
    ],
    "2025-02-15": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 13.9,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 64.25,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 22.85,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 75.55,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 36.4,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 41.8,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 134.33,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 190.95,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 105.2,
      },
    ],
    "2025-02-16": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 68.4,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 67.65,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 29.45,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 32.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 90.75,
      },
      {
        hour: 18,
        saleCount: 10,
        saleTotal: 170.25,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 101.95,
      },
      {
        hour: 20,
        saleCount: 7,
        saleTotal: 166.3,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 126.71,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 60.5,
      },
    ],
    "2025-02-17": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 29.4,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 11.16,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 16.14,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 17.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 23.9,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 50.8,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 24.72,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 18.9,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 14.9,
      },
    ],
    "2025-02-18": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 20.2,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 31.87,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 59.01,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 131.37,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 79.44,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 141.74,
      },
    ],
    "2025-02-19": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 44.35,
      },
      {
        hour: 12,
        saleCount: 6,
        saleTotal: 72.79,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 83.19,
      },
      {
        hour: 14,
        saleCount: 5,
        saleTotal: 47.33,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 27.9,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 25.85,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 103.3,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 162.85,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 45.05,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 19.1,
      },
    ],
    "2025-02-20": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 28.13,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 29.11,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 10.0,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 50.76,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 46.82,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 51.75,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 58.31,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 76.62,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 24.85,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 38.94,
      },
    ],
    "2025-02-21": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 68.25,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 31.1,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 7.16,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 22.49,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 90.53,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 127.27,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 55.72,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 65.33,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 32.9,
      },
    ],
    "2025-02-22": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 24.4,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 54.55,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 43.6,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 16.9,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 28.85,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 102.3,
      },
      {
        hour: 18,
        saleCount: 9,
        saleTotal: 305.35,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 201.97,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 174.74,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 43.3,
      },
    ],
    "2025-02-23": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 34.3,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 31.4,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 44.3,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 19.14,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 146.03,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 162.85,
      },
      {
        hour: 19,
        saleCount: 8,
        saleTotal: 217.36,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 56.75,
      },
    ],
    "2025-02-24": [
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 14.2,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 11.16,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 35.58,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 116.44,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 50.59,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 84.35,
      },
    ],
    "2025-02-25": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 17.15,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 39.07,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 54.35,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 127.2,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 53.8,
      },
      {
        hour: 20,
        saleCount: 9,
        saleTotal: 202.55,
      },
    ],
    "2025-02-26": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 69.24,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 37.06,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 21.75,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 29.61,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 106.58,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 32.85,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 16.0,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 58.35,
      },
    ],
    "2025-02-27": [
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 20.43,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 44.96,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 22.4,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 98.91,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 2.5,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 124.2,
      },
      {
        hour: 20,
        saleCount: 4,
        saleTotal: 74.6,
      },
    ],
    "2025-02-28": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 109.41,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 13.45,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 19.42,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 17,
        saleCount: 6,
        saleTotal: 152.45,
      },
      {
        hour: 18,
        saleCount: 6,
        saleTotal: 185.8,
      },
      {
        hour: 19,
        saleCount: 8,
        saleTotal: 277.24,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 106.41,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 68.19,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 19.9,
      },
    ],
    "2025-03-01": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 36.85,
      },
      {
        hour: 14,
        saleCount: 6,
        saleTotal: 99.13,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 143.5,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 122.12,
      },
      {
        hour: 19,
        saleCount: 8,
        saleTotal: 328.86,
      },
      {
        hour: 20,
        saleCount: 9,
        saleTotal: 216.1,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 58.94,
      },
    ],
    "2025-03-02": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 53.43,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 48.65,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 19.9,
      },
      {
        hour: 18,
        saleCount: 6,
        saleTotal: 231.19,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 131.55,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 4.98,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 0.0,
      },
    ],
    "2025-03-03": [
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 53.35,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 37.35,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 37.05,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 72.15,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 15.9,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 25.61,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 75.55,
      },
    ],
    "2025-03-04": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 28.4,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 6.36,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 23.1,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 13.52,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 51.8,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 11.95,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 38.4,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 53.75,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 15.95,
      },
    ],
    "2025-03-05": [
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 24.85,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 35.4,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 93.65,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 105.2,
      },
    ],
    "2025-03-06": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 33.88,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 37.8,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 9.95,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 21.67,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 17.9,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 95.1,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 25.11,
      },
    ],
    "2025-03-07": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 9.58,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 50.59,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 11.14,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 34.91,
      },
      {
        hour: 18,
        saleCount: 6,
        saleTotal: 184.52,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 175.05,
      },
      {
        hour: 20,
        saleCount: 9,
        saleTotal: 294.52,
      },
      {
        hour: 21,
        saleCount: 6,
        saleTotal: 213.47,
      },
    ],
    "2025-03-08": [
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 38.35,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 48.93,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 24.9,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 95.15,
      },
      {
        hour: 18,
        saleCount: 10,
        saleTotal: 378.85,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 179.7,
      },
      {
        hour: 20,
        saleCount: 8,
        saleTotal: 225.36,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 10.0,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 52.3,
      },
    ],
    "2025-03-09": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 22.85,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 15.95,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 18.45,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 18.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 89.1,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 35.85,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 29.8,
      },
      {
        hour: 19,
        saleCount: 11,
        saleTotal: 201.05,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 137.45,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 17.9,
      },
    ],
    "2025-03-10": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 28.1,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 39.9,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 137.16,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 44.85,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 11.14,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 111.3,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 58.3,
      },
    ],
    "2025-03-11": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 64.8,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 44.45,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 16.45,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 35.22,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 301.75,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 65.3,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 106.1,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 53.12,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 41.15,
      },
    ],
    "2025-03-12": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 23.5,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 75.5,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 13.9,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 33.76,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 124.8,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 121.1,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 160.35,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 31.19,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 36.05,
      },
    ],
    "2025-03-13": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 41.85,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 13.65,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 47.8,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 27.9,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 123.3,
      },
      {
        hour: 18,
        saleCount: 6,
        saleTotal: 161.68,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 71.08,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 45.75,
      },
    ],
    "2025-03-14": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 66.35,
      },
      {
        hour: 13,
        saleCount: 6,
        saleTotal: 97.5,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 20.68,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 95.7,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 67.7,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 120.55,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 144.94,
      },
      {
        hour: 20,
        saleCount: 10,
        saleTotal: 214.81,
      },
      {
        hour: 21,
        saleCount: 10,
        saleTotal: 164.24,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 84.2,
      },
    ],
    "2025-03-15": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 39.5,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 9.0,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 17.9,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 28.1,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 133.95,
      },
      {
        hour: 18,
        saleCount: 6,
        saleTotal: 214.16,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 135.9,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 134.75,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 69.75,
      },
    ],
    "2025-03-16": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 35.8,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 13.45,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 16.68,
      },
      {
        hour: 14,
        saleCount: 5,
        saleTotal: 122.96,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 13.9,
      },
      {
        hour: 16,
        saleCount: 4,
        saleTotal: 81.2,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 54.98,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 117.0,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 91.55,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 207.25,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 24.85,
      },
      {
        hour: 22,
        saleCount: 1,
        saleTotal: 37.85,
      },
    ],
    "2025-03-17": [
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 83.4,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 45.31,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 35.35,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 41.55,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 89.2,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 24.85,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 171.86,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 106.1,
      },
    ],
    "2025-03-18": [
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 80.22,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 30.05,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 46.8,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 33.35,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 87.15,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 58.9,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 84.52,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 30.85,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 53.7,
      },
    ],
    "2025-03-19": [
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 14.45,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 26.85,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 52.8,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 31.35,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 51.8,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 117.1,
      },
    ],
    "2025-03-20": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 45.47,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 24.9,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 0.0,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 12.95,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 15.45,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 20.4,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 40.62,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 17.51,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 107.5,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 111.0,
      },
    ],
    "2025-03-21": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 11.95,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 7.73,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 63.01,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 34.85,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 43.06,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 110.6,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 91.2,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 75.95,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 91.09,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 74.18,
      },
    ],
    "2025-03-22": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 31.35,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 45.59,
      },
      {
        hour: 14,
        saleCount: 6,
        saleTotal: 110.69,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 41.3,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 74.75,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 22.9,
      },
      {
        hour: 18,
        saleCount: 8,
        saleTotal: 265.29,
      },
      {
        hour: 19,
        saleCount: 11,
        saleTotal: 415.64,
      },
      {
        hour: 20,
        saleCount: 9,
        saleTotal: 216.64,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 137.45,
      },
    ],
    "2025-03-23": [
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 32.4,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 50.85,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 9.95,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 139.0,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 164.34,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 95.09,
      },
      {
        hour: 21,
        saleCount: 5,
        saleTotal: 56.25,
      },
    ],
    "2025-03-24": [
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 54.65,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 10.95,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 60.45,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 26.88,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 24.4,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 34.9,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 26.95,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 7.95,
      },
    ],
    "2025-03-25": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 50.25,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 53.17,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 30.4,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 134.75,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 54.85,
      },
      {
        hour: 19,
        saleCount: 6,
        saleTotal: 135.0,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 114.79,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 18.9,
      },
    ],
    "2025-03-26": [
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 75.8,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 20.85,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 26.95,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 62.25,
      },
      {
        hour: 21,
        saleCount: 7,
        saleTotal: 168.49,
      },
    ],
    "2025-03-27": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 20.45,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 76.6,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 21.2,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 23.9,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 43.8,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 29.05,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 37.4,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 45.3,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 53.0,
      },
    ],
    "2025-03-28": [
      {
        hour: 11,
        saleCount: 3,
        saleTotal: 39.49,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 19.55,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 13.95,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 78.75,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 82.6,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 41.65,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 108.6,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 155.65,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 168.4,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 41.9,
      },
    ],
    "2025-03-29": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 7.95,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 6.95,
      },
      {
        hour: 14,
        saleCount: 2,
        saleTotal: 75.35,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 29.85,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 57.75,
      },
      {
        hour: 17,
        saleCount: 7,
        saleTotal: 141.15,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 82.15,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 81.3,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 140.65,
      },
      {
        hour: 21,
        saleCount: 4,
        saleTotal: 131.55,
      },
    ],
    "2025-03-31": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 34.05,
      },
      {
        hour: 12,
        saleCount: 5,
        saleTotal: 87.65,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 12.72,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 14.76,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 104.75,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 26.66,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 97.15,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 54.25,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 50.1,
      },
    ],
    "2025-04-01": [
      {
        hour: 10,
        saleCount: 2,
        saleTotal: 35.79,
      },
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 37.4,
      },
      {
        hour: 12,
        saleCount: 2,
        saleTotal: 35.68,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 46.35,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 46.85,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 178.4,
      },
      {
        hour: 19,
        saleCount: 8,
        saleTotal: 152.81,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 32.88,
      },
    ],
    "2025-04-02": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 11.45,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 30.9,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 42.15,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 4.0,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 23.5,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 35.1,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 26.4,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 32.1,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 29.95,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 60.99,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 23.4,
      },
    ],
    "2025-04-03": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 53.25,
      },
      {
        hour: 12,
        saleCount: 4,
        saleTotal: 77.85,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 15.9,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 19.12,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 7.16,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 148.25,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 86.65,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 87.65,
      },
    ],
    "2025-04-04": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 16.9,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 59.57,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 29.4,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 25.95,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 60.16,
      },
      {
        hour: 18,
        saleCount: 5,
        saleTotal: 202.35,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 70.38,
      },
    ],
    "2025-04-05": [
      {
        hour: 10,
        saleCount: 2,
        saleTotal: 48.85,
      },
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 24.12,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 119.07,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 107.95,
      },
      {
        hour: 19,
        saleCount: 8,
        saleTotal: 263.15,
      },
      {
        hour: 20,
        saleCount: 8,
        saleTotal: 226.5,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 26.4,
      },
    ],
    "2025-04-06": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 68.3,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 50.02,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 152.5,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 49.8,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 68.75,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 58.8,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 91.55,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 94.69,
      },
      {
        hour: 20,
        saleCount: 5,
        saleTotal: 163.05,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 22.9,
      },
    ],
    "2025-04-07": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 11,
        saleCount: 3,
        saleTotal: 57.85,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 7.73,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 16.95,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 15.9,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 36.05,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 29.9,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 95.47,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 87.15,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 23.85,
      },
    ],
    "2025-04-08": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 6.95,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 91.05,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 82.4,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 88.42,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 190.64,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 39.05,
      },
      {
        hour: 21,
        saleCount: 2,
        saleTotal: 0.0,
      },
    ],
    "2025-04-09": [
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 69.8,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 3.6,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 12.66,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 44.9,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 62.87,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 4.5,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 31.6,
      },
    ],
    "2025-04-10": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 29.15,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 15.52,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 50.3,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 45.8,
      },
      {
        hour: 16,
        saleCount: 2,
        saleTotal: 75.25,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 7.05,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 68.0,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 45.85,
      },
      {
        hour: 21,
        saleCount: 3,
        saleTotal: 62.28,
      },
    ],
    "2025-04-11": [
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 65.85,
      },
      {
        hour: 13,
        saleCount: 4,
        saleTotal: 128.83,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 16.9,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 54.3,
      },
      {
        hour: 17,
        saleCount: 1,
        saleTotal: 22.4,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 202.3,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 63.77,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 133.45,
      },
      {
        hour: 22,
        saleCount: 2,
        saleTotal: 5.0,
      },
    ],
    "2025-04-12": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 3.79,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 7.94,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 7.16,
      },
      {
        hour: 14,
        saleCount: 4,
        saleTotal: 168.7,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 39.55,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 111.2,
      },
      {
        hour: 17,
        saleCount: 4,
        saleTotal: 82.8,
      },
      {
        hour: 18,
        saleCount: 8,
        saleTotal: 150.35,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 59.65,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 70.6,
      },
      {
        hour: 21,
        saleCount: 1,
        saleTotal: 22.95,
      },
    ],
    "2025-04-13": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 19.15,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 70.6,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 52.55,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 7.16,
      },
      {
        hour: 15,
        saleCount: 4,
        saleTotal: 70.65,
      },
      {
        hour: 16,
        saleCount: 5,
        saleTotal: 131.79,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 46.75,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 43.45,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 72.2,
      },
    ],
    "2025-04-14": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 15.95,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 4.94,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 58.9,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 55.7,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 64.1,
      },
      {
        hour: 19,
        saleCount: 7,
        saleTotal: 145.82,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 7.95,
      },
    ],
    "2025-04-15": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 32.05,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 5.44,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 44.7,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 58.76,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 45.5,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 42.05,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 81.53,
      },
      {
        hour: 18,
        saleCount: 3,
        saleTotal: 57.81,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 91.6,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 132.6,
      },
    ],
    "2025-04-16": [
      {
        hour: 11,
        saleCount: 2,
        saleTotal: 24.85,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 18.37,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 87.6,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 104.05,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 77.65,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 43.75,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 26.85,
      },
    ],
    "2025-04-17": [
      {
        hour: 10,
        saleCount: 1,
        saleTotal: 34.69,
      },
      {
        hour: 11,
        saleCount: 5,
        saleTotal: 66.95,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 19.39,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 46.95,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 49.8,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 54.25,
      },
      {
        hour: 18,
        saleCount: 1,
        saleTotal: 16.9,
      },
      {
        hour: 19,
        saleCount: 5,
        saleTotal: 124.45,
      },
      {
        hour: 20,
        saleCount: 2,
        saleTotal: 33.8,
      },
    ],
    "2025-04-18": [
      {
        hour: 11,
        saleCount: 3,
        saleTotal: 49.75,
      },
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 82.6,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 52.76,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 12.95,
      },
      {
        hour: 15,
        saleCount: 2,
        saleTotal: 47.7,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 33.04,
      },
      {
        hour: 17,
        saleCount: 5,
        saleTotal: 121.0,
      },
      {
        hour: 18,
        saleCount: 7,
        saleTotal: 128.02,
      },
      {
        hour: 19,
        saleCount: 3,
        saleTotal: 50.51,
      },
      {
        hour: 20,
        saleCount: 3,
        saleTotal: 51.51,
      },
    ],
    "2025-04-19": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 8.95,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 26.9,
      },
      {
        hour: 13,
        saleCount: 3,
        saleTotal: 45.78,
      },
      {
        hour: 14,
        saleCount: 1,
        saleTotal: 0.0,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 17.9,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 47.87,
      },
      {
        hour: 17,
        saleCount: 6,
        saleTotal: 120.9,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 141.6,
      },
      {
        hour: 19,
        saleCount: 4,
        saleTotal: 215.47,
      },
      {
        hour: 20,
        saleCount: 1,
        saleTotal: 13.95,
      },
    ],
    "2025-04-20": [
      {
        hour: 11,
        saleCount: 1,
        saleTotal: 32.9,
      },
      {
        hour: 12,
        saleCount: 3,
        saleTotal: 51.8,
      },
      {
        hour: 13,
        saleCount: 1,
        saleTotal: 5.95,
      },
      {
        hour: 14,
        saleCount: 3,
        saleTotal: 106.75,
      },
      {
        hour: 15,
        saleCount: 3,
        saleTotal: 75.6,
      },
      {
        hour: 16,
        saleCount: 1,
        saleTotal: 11.95,
      },
      {
        hour: 17,
        saleCount: 3,
        saleTotal: 50.25,
      },
      {
        hour: 18,
        saleCount: 4,
        saleTotal: 64.68,
      },
      {
        hour: 19,
        saleCount: 1,
        saleTotal: 25.35,
      },
      {
        hour: 20,
        saleCount: 6,
        saleTotal: 149.15,
      },
    ],
    "2025-04-21": [
      {
        hour: 12,
        saleCount: 1,
        saleTotal: 51.0,
      },
      {
        hour: 13,
        saleCount: 2,
        saleTotal: 57.2,
      },
      {
        hour: 15,
        saleCount: 1,
        saleTotal: 25.9,
      },
      {
        hour: 16,
        saleCount: 3,
        saleTotal: 43.36,
      },
      {
        hour: 17,
        saleCount: 2,
        saleTotal: 45.1,
      },
      {
        hour: 18,
        saleCount: 2,
        saleTotal: 88.01,
      },
      {
        hour: 19,
        saleCount: 2,
        saleTotal: 47.11,
      },
    ],
  };

  const match: any = useRouteMatch();
  const idToken = getCookie("idToken");

  const getAllFilterLocation = async () => {
    // Call the API to fetch all filter locations
    fetchAllFilterLocations("")
      .then((res) => {
        // If the request is successful
        let locationList: any = [];
        // Check if the response data is not empty
        if (!_.isEmpty(res.data.data)) {
          // Iterate over each location in the response data
          res.data.data.map((location: any) => {
            // Push location details to the locationList array
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            });
          });
        }

        // Update the location selector list with fetched locations
        setLocationSelectorList(locationList);
        // Set the flag to indicate that location info is fetched
        setIsGetLocationInfo(true);
      })
      .catch(() => {
        // If an error occurs during fetching, handle it by setting an error message
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };

  /* Get all shift information using API call and response data set to driverSummaryNodeList state. */
  const getShiftFilterInfo = async (filter: any) => {
    const startEndDate = extractDateRange(filter);
    setStartDate(startEndDate.startDate);
    setEndDate(startEndDate.endDate);
    try {
      // Call the API to fetch sale item report information
      const res = await fetchMonthlySalesReport(
        idToken,
        match.params.locationId,
        filter,
      );
      if (Object.values(res.data.data).length === 0) {
        setDriverSummaryNodeList({ id: 1 });
      } else {
        setDriverSummaryNodeList(res.data.data);
      }

      setIsLoadingPage(false);
      // getSaleItemReportInfoCombineModifierFalse(filter, basedOnShift, output);
      // Once the data is fetched successfully, call getGroupInfo to proceed with data processing
    } catch (err) {
      // If an error occurs during fetching, handle it by setting loading state and displaying error message
      setIsLoadingPage(false);
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      setDriverSummaryNodeList({ id: 1 });
    }
  };

  useEffect(() => {
    getAllFilterLocation();
    document.title = "Sale - Monthly Sales Report";
  }, []);

  // Get filter data
  const handleFilterData = (filterData: any) => {
    // setIsLoadingPage(true);
    setFilterData(filterData);
    // getShiftFilterInfo(filterData);
  };

  const getReportUsingButton = () => {
    setIsLoadingPage(true);
    getShiftFilterInfo(filterData);
  };

  const handleOnClickText = () => {
    setOpenFilterCard(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  const handleLocationSelectorTypingList = (searchName: any) => {};
  return (
    <>
      <Box>
        <SaleReport
          handleFilterData={handleFilterData}
          locationSelectorList={locationSelectorList}
          handleLocationSelectorTypingList={handleLocationSelectorTypingList}
          setFilterDetails={setFilterDetails}
          availableFilter={hourlySalesFilterObject}
          isOpenSkeletonLoading={isLoadingPage}
          nodeList={driverSummaryNodeList}
          filterDetails={filterDetails}
          title={""}
          isChart={false}
          isGetLocationInfo={isGetLocationInfo}
          isSaleItem={true}
          locationSelectedList={locationSelectedList}
          setLocationSelectedList={setLocationSelectedList}
          openFilterCard={openFilterCard}
          setOpenFilterCard={setOpenFilterCard}
          handleOnClickText={handleOnClickText}
          topic="Monthly Sales Report"
          isReport={true}
          isYearlyDateRange={true}
          isNeedDropdown={true}
          isNeedTimeout={true}
          isShowButton={true}
          getReportUsingButton={getReportUsingButton}
        >
          <HourlySalesReportNode
            isLoading={isLoadingPage}
            startDate={startDate}
            endDate={endDate}
            filterDetails={filterDetails}
            locationSelectedList={locationSelectedList}
            handleOnClickText={handleOnClickText}
            driverSummaryNodeList={driverSummaryNodeList}
            weeklySales={weeklySales}
            weeklySalesCountValue={weeklySalesCountValue}
            weeklySalesTotalValue={weeklySalesTotalValue}
          />
          {/* {!_.isEmpty(driverSummaryNodeList) && (
            <Pagination
              handleChangePaginationUsingSelector={
                handleChangePaginationUsingSelector
              }
              handleChangePaginationUsingPageNumber={
                handleChangePaginationUsingPageNumber
              }
              totalPages={totalPages}
              currentPage={currentPage}
              pageSize={pageSize}
              isShift={true}
              totalResult={totalResult}
            />
          )} */}
        </SaleReport>

        <DefaultAlert
          open={!!error}
          handleClose={() => setError("")}
          message={error}
          severity="error"
        />
      </Box>
    </>
  );
};

export default withAuthority(MonthlySalesReport, Authorities.SALE_READ);
